import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./NoPLCConnectionWarning.styles";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

export const NoPLCConnectionWarning = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.warningContainer}>
            <WarningRoundedIcon className={classes.icon} />
            <Box className={classes.warningTitlesBox}>
                <Typography className={classes.warningTitle} variant="subtitle2">
                    {t("HMI.no_plc_connection_warning")}
                </Typography>
                <Typography className={classes.warningTitle} variant="subtitle2">
                    {t("HMI.manual_mode_engaged").toUpperCase()}
                </Typography>
            </Box>
        </Box>
    );
};
